import MyDiv from "./employerDetails.style";
import { useEffect, useState } from "react";
import { useFetch } from "../../../../../hooks/useFetch";
import { CustomToast } from "../../../../../components";
import { EmployeerDetail } from "./moda";
import EditEmployement from "./editEmployement";
import DenefitsAndIdNumbers from "./benefitsAndIdNumbers";
import ExperienceDetail from "./experienceDetail";
import SalaryDetail from "./salaryDetail";
import Hierarchy from "./hierarchyDetails";

export interface props {
  employeeId: number | null;
}

const EmployerDetails = ({ employeeId }: props) => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);

  const [employeerDetail, setEmployeerDetail] = useState<EmployeerDetail>();

  async function loadEmployeerDetail() {
    const response = await fetchApi("Hrlense_Employee/employeerDetail", "GET", null, `employeeId=${employeeId}`, "");
    if (response) {
      setEmployeerDetail(response);
    }
  }

  useEffect(() => {
    loadEmployeerDetail();
  }, [employeeId]);

  function onComplete() {
    loadEmployeerDetail();
  }

  return (
    <MyDiv>
      <EditEmployement employeeId={employeeId} data={employeerDetail} onComplete={onComplete} />
      <Hierarchy employeeId={employeeId} personalDetail={employeerDetail} reload={onComplete} />
      <DenefitsAndIdNumbers employeeId={employeeId} data={employeerDetail} onComplete={onComplete} />
      <ExperienceDetail employeeId={employeeId} data={employeerDetail} onComplete={onComplete} />
      <SalaryDetail employeeId={employeeId} data={employeerDetail} onComplete={onComplete} />

    </MyDiv>
  );
};

export default EmployerDetails;
